<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'
import { omit, merge } from "lodash";

export default {
  mixins: [fandomBasicMixin],
  mounted() {
  },
  methods: {
  },
  computed: {
    launchContent() {
      const launchContent = this.getContent(this.content.related_content);
      const mergeInContent = omit(this.content, ["id", "name", "layout"]);
      return merge(launchContent, mergeInContent);
    }
  }
}
</script>

<template>
  <component :is="launchContent.layout" :content="launchContent" v-easyadmin="easyadminId" :class="contentType"></component>
</template>

<style lang="scss" scoped>
[tile-launch-component] {
}
</style>